var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ticimax-filter-item-editor" }, [
    _c(
      "section",
      { staticClass: "header" },
      [
        _c("FieldIconPreview", { attrs: { attribute: _vm.clone.attribute } }),
        _vm._v(" "),
        _c("span", { staticClass: "title" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("ticimax.attributes." + _vm.getAttributeValue())) +
              "\n        "
          ),
        ]),
        _vm._v(" "),
        _c(
          "md-button",
          {
            staticClass: "md-icon-button md-mini",
            on: { click: _vm.onClosed },
          },
          [_c("md-icon", [_vm._v("close")])],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("section", { staticClass: "rules-section" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("chatbotv2.condition"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "rules" },
        _vm._l(_vm.getOperators(), function (rule) {
          return _c(
            "div",
            {
              key: rule.value,
              staticClass: "rule",
              class: { active: rule.value === _vm.clone.rule },
              on: {
                click: function () {
                  return _vm.changeRule(rule.value)
                },
              },
            },
            [
              rule.value === "equal"
                ? _c("font-awesome-icon", { attrs: { icon: "equals" } })
                : rule.value === "not_equal"
                ? _c("font-awesome-icon", { attrs: { icon: "not-equal" } })
                : rule.value === "less_than"
                ? _c("font-awesome-icon", { attrs: { icon: "less-than" } })
                : rule.value === "less_or_equal"
                ? _c("font-awesome-icon", {
                    attrs: { icon: "less-than-equal" },
                  })
                : rule.value === "greater_than"
                ? _c("font-awesome-icon", { attrs: { icon: "greater-than" } })
                : rule.value === "greater_or_equal"
                ? _c("font-awesome-icon", {
                    attrs: { icon: "greater-than-equal" },
                  })
                : _vm._e(),
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("chatbotv2.filters." + rule.value)) +
                  "\n            "
              ),
            ],
            1
          )
        }),
        0
      ),
    ]),
    _vm._v(" "),
    !["empty", "non_empty"].includes(_vm.clone.rule)
      ? _c("section", { staticClass: "value-section" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("chatbotv2.value"))),
          ]),
          _vm._v(" "),
          _vm.isNumericAttribute()
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.clone.value,
                    expression: "clone.value",
                  },
                ],
                class: { error: _vm.isValueValid(), focused: _vm.inputFocused },
                attrs: {
                  required: "required",
                  type: "number",
                  placeholder: "Value",
                  min: -9007199254740991,
                  max: 9007199254740991,
                  step: 1,
                },
                domProps: { value: _vm.clone.value },
                on: {
                  focus: function ($event) {
                    _vm.inputFocused = true
                  },
                  blue: function ($event) {
                    _vm.inputFocused = false
                  },
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.clone, "value", $event.target.value)
                  },
                },
              })
            : _vm.isBoolean()
            ? _c(
                "span",
                [
                  _c(
                    "a-select",
                    {
                      staticClass: "select-attribute",
                      attrs: { value: _vm.clone.value + "" },
                      on: {
                        change: function (e) {
                          _vm.clone.value = e
                        },
                      },
                    },
                    _vm._l(_vm.getBooleanValues(), function (booleanValue) {
                      return _c(
                        "a-select-option",
                        {
                          key: booleanValue.label + "-" + booleanValue.value,
                          attrs: { value: booleanValue.value + "" },
                        },
                        [
                          _vm._v(
                            _vm._s(booleanValue.label) + "\n                "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm.isSelect()
            ? _c(
                "span",
                [
                  _c(
                    "a-select",
                    {
                      staticClass: "select-attribute",
                      attrs: { value: _vm.clone.value },
                      on: {
                        change: function (e) {
                          _vm.clone.value = e
                        },
                      },
                    },
                    _vm._l(_vm.getOptions(), function (opt) {
                      return _c(
                        "a-select-option",
                        { key: opt.value, attrs: { value: opt.value } },
                        [_vm._v(_vm._s(opt.label) + "\n                ")]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.clone.value,
                    expression: "clone.value",
                  },
                ],
                class: { error: _vm.isValueValid(), focused: _vm.inputFocused },
                attrs: {
                  required: "required",
                  type: "text",
                  placeholder: _vm.$t("chatbotv2.value"),
                },
                domProps: { value: _vm.clone.value },
                on: {
                  focus: function ($event) {
                    _vm.inputFocused = true
                  },
                  blue: function ($event) {
                    _vm.inputFocused = false
                  },
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.clone, "value", $event.target.value)
                  },
                },
              }),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "apply" },
      [
        _c(
          "a-button",
          {
            attrs: {
              type: "primary",
              disabled:
                !["empty", "non_empty"].includes(_vm.clone.rule) &&
                _vm.isValueValid(),
            },
            on: { click: _vm.submit },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("chatbotv2.applyFilter")) +
                "\n        "
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }